import type { FrontendWidget } from '../types';
import { TeachersComponent } from './TeachersComponent';
import { TeachersComponentB } from './TeachersComponentB';
import { TeachersComponentC } from './TeachersComponentC';
import type { TeachersWidgetConfig, TeachersWidgetResolved } from './types';

export const teachersWidget: FrontendWidget<
  TeachersWidgetConfig,
  TeachersWidgetResolved
> = {
  componentType: 'widgets.teachers-widget',
  displayName: 'Teachers Widget',
  ComponentA: TeachersComponent,
  ComponentB: TeachersComponentB,
  ComponentC: TeachersComponentC,
  // No resolveSync — lookup widget. Resolved data arrives via POST /api/resolve-widgets.
};
